function formatArabicDate(value) {
  const date = value ? new Date(value) : new Date();
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("ar-SA", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
}

export function generateDemandLetter(input) {
  const {
    creditorName,
    debtorName,
    amount,
    claimBasis,
    dueDate,
    paymentPeriodDays,
    notes,
    letterDate,
  } = input;

  const todayText = formatArabicDate(letterDate);
  const dueDateText = dueDate ? formatArabicDate(dueDate) : "";
  const amountText = Number(amount || 0).toLocaleString("en-US");

  const deadlineText = dueDateText
    ? `وذلك بحد أقصى في تاريخ ${dueDateText}.`
    : `وذلك خلال مدة ${paymentPeriodDays || 7} أيام من تاريخ استلام هذا الإنذار.`;

  const optionalNotes = notes
    ? `\nملاحظات إضافية:\n${notes.trim()}\n`
    : "";

  const letter = [
    "بسم الله الرحمن الرحيم",
    "",
    `التاريخ: ${todayText}`,
    "",
    `السيد/ ${debtorName || "المدين المحترم"}`,
    "تحية طيبة وبعد،",
    "",
    "الموضوع: مطالبة مالية",
    "",
    `نفيدكم بأن السيد/ ${creditorName || "الدائن"} له في ذمتكم مبلغ وقدره (${amountText}) ريال سعودي،`,
    `وذلك مقابل: ${claimBasis || "الالتزام محل المطالبة"}.`,
    "",
    `نطلب منكم سداد المبلغ المشار إليه أعلاه ${deadlineText}`,
    "وفي حال عدم السداد خلال المهلة المحددة، فسيتم اتخاذ الإجراءات النظامية اللازمة للمطالبة بالحق دون أي إشعار إضافي.",
    optionalNotes.trimEnd(),
    "",
    "وتفضلوا بقبول فائق الاحترام،",
    "",
    "مقدم المطالبة / وكيله",
    `الاسم: ${creditorName || "—"}`,
  ]
    .filter(Boolean)
    .join("\n");

  return {
    letter,
    generatedAt: todayText,
  };
}

